<template>
    <article v-if="mailing">
        <form-mailing :edit="mailing"></form-mailing>
    </article>
</template>

<script>
import { ref } from "vue";
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import { CheckIcon, PencilAltIcon } from "@heroicons/vue/outline";

export default {
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckIcon,
        PencilAltIcon,
    },
    mounted() {
        Eventing.listen("closeModal", () => (this.open = false));
    },
    created() {},
    data() {
        const open = ref(true);

        return {
            open,
            mailing: {
                header: document.head.querySelector('meta[name="company"]')
                    ?.content,
                template_bg: document.head.querySelector(
                    'meta[name="template_bg"]'
                )?.content,
                template_text: document.head.querySelector(
                    'meta[name="template_text"]'
                )?.content,
                status: "concept",
                role_id: "",
            },
        };
    },
    methods: {},
};
</script>
